// src/store/thunks/six/deleteSixThunk.ts
import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { withErrorHandling, withLoader } from "@/store/thunks/thunkWrappers";
import type { DeleteSixPayload, DeleteSixResponse } from "@/types/create-six.types";

export const deleteSixThunk = createAppAsyncThunk<
  DeleteSixResponse,
  DeleteSixPayload,
  { rejectValue: { message: string } }
>(
  "six/deleteSix",
  withLoader(
    withErrorHandling(async(payload, thunkAPI) => {
      const { extra } = thunkAPI;
      return await extra.createSixService.deleteSix(payload.id);
    })
  )
);
